import { requests } from '../../api/services';
import {
    CONTROLLING_AGENCY_REVENUE_CAMPAIGNS_URL,
    CONTROLLING_AGENCY_REVENUE_COMPANIES_URL,
    CONTROLLING_KPI_URL,
    CONTROLLING_LONG_TERM_INCOMING_INVOICES_URL,
    CONTROLLING_OUTGOING_INVOICES_URL,
    CONTROLLING_URL,
} from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import {
    ControllingKpisParams,
    ControllingParams,
    ICampaign,
    ICompany,
    IIncomingDeferral,
    IIncomingKpis,
} from '../../model/controlling/Controlling';

export const ContollingService = {
    getControlling: (params: ControllingParams): Promise<BaseModel<IIncomingDeferral[]>> =>
        requests.get(`${CONTROLLING_URL}`, params),
    getKpis: (params: ControllingKpisParams): Promise<BaseModel<IIncomingKpis[]>> =>
        requests.get(`${CONTROLLING_KPI_URL}`, params),
    getLongTermIncomingInvoices: (params: ControllingParams): Promise<BaseModel<IIncomingDeferral[]>> =>
        requests.get(`${CONTROLLING_LONG_TERM_INCOMING_INVOICES_URL}`, params),
    getOutgoingInvoices: (params: ControllingParams): Promise<BaseModel<IIncomingDeferral[]>> =>
        requests.get(`${CONTROLLING_OUTGOING_INVOICES_URL}`, params),
    getAgencyRevenueCampaigns: (params: ControllingKpisParams): Promise<BaseModel<ICampaign[]>> =>
        requests.get(`${CONTROLLING_AGENCY_REVENUE_CAMPAIGNS_URL}`, params),
    getAgencMarginCompanies: (params: ControllingKpisParams): Promise<BaseModel<ICompany[]>> =>
        requests.get(`${CONTROLLING_AGENCY_REVENUE_COMPANIES_URL}`, params),
};
